/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { getApiKeyDeviceRequestSchema } from "./getApiKeyDeviceRequestSchema.ts";
import { responseApiKeyDeviceSchema } from "./responseApiKeyDeviceSchema.ts";

export const deviceOrgUnitGetApiKeyCreatePathOrgUnitIdSchema = z.uuid();

export const deviceOrgUnitGetApiKeyCreateStatus200Schema = responseApiKeyDeviceSchema.describe("Для документации, сериализатор вывода api-key для устройства.");

export const deviceOrgUnitGetApiKeyCreateResponseSchema = deviceOrgUnitGetApiKeyCreateStatus200Schema;

export const deviceOrgUnitGetApiKeyCreateDataSchemaJson = getApiKeyDeviceRequestSchema.describe("Сериализатор получения и проверки кода устройства.");

export const deviceOrgUnitGetApiKeyCreateDataSchemaXml = getApiKeyDeviceRequestSchema.describe("Сериализатор получения и проверки кода устройства.");

export const deviceOrgUnitGetApiKeyCreateDataSchema = z.union([deviceOrgUnitGetApiKeyCreateDataSchemaJson, deviceOrgUnitGetApiKeyCreateDataSchemaXml]);
